import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import {
  PricebookChangeSummary,
  PricebookValueChange,
} from "../../../../types/price-book.type";
import { numberWithCommas } from "../../../../utils";
import { formatDiscountPercent } from "../constants";

interface ChangeCountChipsProps {
  summary: PricebookChangeSummary;
}

/** How many products a draft adds, takes off and changes; shared by the apply dialog and the schedule cards. */
export function ChangeCountChips({ summary }: ChangeCountChipsProps) {
  return (
    <>
      <Chip
        size="small"
        variant="outlined"
        label={`เพิ่ม ${numberWithCommas(summary.added_count)}`}
      />
      <Chip
        size="small"
        variant="outlined"
        label={`นำออก ${numberWithCommas(summary.removed_count)}`}
      />
      <Chip
        size="small"
        variant="outlined"
        label={`เปลี่ยน ${numberWithCommas(summary.changed_count)}`}
      />
    </>
  );
}

interface BookDiscountChangeLineProps {
  change: PricebookValueChange<number>;
}

/** The book % before, struck through, and after; nothing when it stays the same. */
export function BookDiscountChangeLine({ change }: BookDiscountChangeLineProps) {
  if (change.old === change.new) return null;

  return (
    <Typography variant="body2">
      ส่วนลดทั้งสมุด <s>{formatDiscountPercent(change.old)}</s> →{" "}
      <b>{formatDiscountPercent(change.new)}</b>
    </Typography>
  );
}
